export const uuid = () => {
  return crypto.randomUUID();
};
